import { useNavigate } from "react-router-dom";
import { convertTextToSlugify, encodeParam } from "./utils";

export const useCustomNavigation = () => {
    const navigate = useNavigate();

    const handleNavigate = (item: any) => {
        if (!item?.type) return;
        const { type, id, name } = item;
        let url = '';
        const encodedId = encodeParam(id || "");
        const slugName = convertTextToSlugify(name?.trim() || '');

        switch (type) {
            case 'registration':
                url = `/registration`;
                break;
            case 'destinationinfo':
            case 'city':
                url = `/destinationinfo/${encodedId}${slugName && `/${slugName}`}`;
                break;
            case 'airportInformation':
                url = `/airportinformation/${encodedId}${slugName && `/${slugName}`}`;
                break;
            // case 'speciality':
            // case 'packages':
            //     url = `/packages/${encodedId}${slugName && `/${slugName}`}`;
            //     break;
            case 'newsdetails':
                url = `/newsdetails/${encodedId}${slugName && `/${slugName}`}`;
                break;
            case 'newsroomdetails':
                url = `/newsroomdetails/${encodedId}${slugName && `/${slugName}`}`;
                break;
            case 'package':
                url = `/package/${encodedId}${slugName && `/${slugName}`}`;
                break;
            case 'whatwedo':
                url = `/whatwedo/${encodedId}${slugName && `/${slugName}`}`;
                break;
            case 'ourstrengths':
                url = `/our-strengths${encodedId && `/${encodedId}`}${slugName && `/${slugName}`}`;
                break;
            case 'blogdetails':
                url = `/blogdetails${encodedId && `/${encodedId}`}${slugName && `/${slugName}`}`;
                break;
            case 'articledetails':
                url = `/articledetails${encodedId && `/${encodedId}`}${slugName && `/${slugName}`}`;
                break;
            case 'testimonial':
                url = `/testimonials${encodedId && `/${encodedId}`}${slugName && `/${slugName}`}`;
                break;
            default:
                return;
        }
        if (url && type === "package")
            window.open(url, "_blank");
        else {
            navigate(url);
            window.scrollTo(0, 0);
        }
    };

    const handleNavigatePackages = (item: any) => {
        if (!item?.type) return;
        const { type, id, name, openInNewTab } = item;
        let url = '';
        const encodedId = encodeParam(id || "");
        const encodedType = encodeParam(type || "");
        const slugName = convertTextToSlugify(name?.trim() || '');
        url = `/packages/${encodedId}/${encodedType}${slugName && `/${slugName}`}`;

        if (openInNewTab) {
            window.open(url, "_blank");
        } else {
            navigate(url);
        }
    }
    const handleNavigateItineraryPreview = (item: any) => {
        if (!item?.packageid) return;
        const { packageid, itinerarydateid, categorydeparturecityid, departuredate, name } = item;
        let url = '';
        const encodedId = encodeParam(String(packageid) || "");
        const encodeditinerarydateid = encodeParam(String(itinerarydateid) || "");
        const encodedcategorydeparturecityid = encodeParam(String(categorydeparturecityid) || "");
        const encodeddeparturedate = encodeParam(String(departuredate) || "");
        const slugName = convertTextToSlugify(name?.trim() || '');
        url = `/itinerary-preview/${encodedId}${encodeditinerarydateid && `/${encodeditinerarydateid}`}${encodedcategorydeparturecityid && `/${encodedcategorydeparturecityid}`}${encodeddeparturedate && `/${encodeddeparturedate}`}${slugName && `/${slugName}`}`;
        window.open(url, "_blank");
    }
    return { handleNavigate, handleNavigatePackages, handleNavigateItineraryPreview };
};